import { useState } from 'react'
import { PRODUCT_NAME, TAGLINE } from './brand'
import LegalModal, { type LegalDoc } from './LegalModal'

export default function Footer() {
  const year = new Date().getFullYear()
  const [legalDoc, setLegalDoc] = useState<LegalDoc | null>(null)
  return (
    <footer className="shrink-0 border-t border-ob-secondary/20 bg-ob-surface px-4 py-5 md:px-16">
      <div className="flex flex-col items-center justify-between gap-2 font-body text-xs text-ob-secondary sm:flex-row">
        <span>
          © {year} {PRODUCT_NAME} · {TAGLINE}
        </span>
        <nav className="flex items-center gap-4">
          <button
            type="button"
            onClick={() => setLegalDoc('privacy')}
            className="transition-colors hover:text-ob-ink"
          >
            Privacy
          </button>
          <button
            type="button"
            onClick={() => setLegalDoc('terms')}
            className="transition-colors hover:text-ob-ink"
          >
            Terms
          </button>
        </nav>
      </div>
      {legalDoc && <LegalModal doc={legalDoc} onClose={() => setLegalDoc(null)} />}
    </footer>
  )
}
